const TopRanksModule = () => {
  return <h4 style={{ margin: 0 }}>랭킹 정보(Top 3)</h4>;
};

export default TopRanksModule;
